import React, { Component } from 'react';
import { Button, Icon, Label, Grid, Divider, Header, Input, Image } from 'semantic-ui-react';
import styles from './uploadSTL.module.css'
import { Route } from 'react-router-dom'
import authObj from './../lib/auth';
import { connect } from "react-redux";
import Dropzone from 'react-dropzone';

class UploadSTL extends Component {
    constructor(props) {
        super(props);
        this.state = {
            InfoHeader: "Usage instructions",
            description1: "Segmentation works on STL file",
            description2: "For best results use fine, medium & coarse resolution STL meshes exported by Autodesk Inventor",
            description3: "Click 'Start Segmentation' after selecting the file",
            content: "Not yet selected",
            file: null,
            filename: "",
            isButtonDisabled: true,
            isLoggedIn: false,
            isDragHover: false
        };
        authObj.load(true).then(() => this.onAuthLoad());
    }

    onAuthLoad() {
        this.setState({
            isLoggedIn: true
        })
    }

    onChangeFile(files) {
        const file = files[0];
        const fileStripped = file.name.split('.');
        fileStripped.pop();
        const fileName = fileStripped.join('.');
        // console.log(fileName);
        this.setState({
            content: file.name,
            file: file,
            isButtonDisabled: false,
            filename: fileName
        })
    }

    onDragOver() {

    }

    onDragLeave() {

    }

    onChangeFileName() {
        const filenameInpt = document.getElementById('filename');
        const filename = filenameInpt.value;
        this.setState({
            filename: filename
        })
    }

    createProject(history) {
        this.setState({
            history: history
        })
        let sendData = {
            "action": "create-project",
            "data": { "Name": this.state.filename }
        }

        this.props.webSocketClient.run(sendData, this.onProjectCreated.bind(this))
    }

    onProjectCreated(data) {
        this.props.handleSegmentation(this.state.file, this.state.history);
        this.state.history.push('/geom/' + data.data.body.UID);
    }

    componentWillMount() {
        this.props.updateParentState()
    }

    componentDidMount() {
        window.gtag('config', 'UA-138495762-1', { 'page_path': window.location.pathname + window.location.search });
    }

    render() {
        const fullHeight = (this.props.app.windowSize.height - 80) + 'px'
        // console.log('isDragHover', this.state.isDragHover)
        return (
            <div style={{ height: fullHeight }} className={"shbg-grey-pallet threehundred custom-section-height auto-height-tablet auto-height-mobile ui segment stackable grid no-border no-padding no-margin no-radius no-shadow"}>
                <div style={{ height: fullHeight }} className={"custom-section-height auto-height-tablet auto-height-mobile row no-margin no-padding"}>
                    <div className={"sixteen wide mobile sixteen wide tablet sixteen wide computer column no-margin no-padding"}>
                        <div className={"container-fluid responsive-padding padding-large"}>
                            <div className={"content-block vertical-align-middle"}>
                                <div className={"inner-content position-center text-align-center"}>
                                    <div className={'container-limit max-width-700'}>
                                        <div className={"ui red header font-weight-bold"}>
                                            Try on new geometry
                                        </div>
                                        <div className={'ui hidden divider'}></div>
                                    </div>
                                </div>
                                <div className={"inner-content position-center"}>
                                    <div className={"ui segments no-border material-shadow-5dp container-limit max-width-700"}>
                                        <div className={"ui segment no-border"}>
                                            <div className={'ui grid'}>
                                                <div className={"sixteen wide mobile sixteen wide tablet eight wide computer column no-margin no-padding"}>
                                                    <div className={"container-fluid responsive-padding"}>
                                                        <div className={"content-block vertical-align-middle"}>
                                                            <div className={"inner-content position-center"}>
                                                                <div className={"ui text blue small header font-weight-bold"}>
                                                                    {this.state.InfoHeader}
                                                                </div>
                                                                <div className={"sh-full-width-list"}>
                                                                    <i className={"ellipsis vertical blue icon"}></i>
                                                                    <h4 className={"content ui header"}>
                                                                        {this.state.description1}
                                                                    </h4>
                                                                </div>
                                                                <div className={"sh-full-width-list"}>
                                                                    <i className={"ellipsis vertical blue icon"}></i>
                                                                    <h4 className={"content ui header"}>
                                                                        {this.state.description2}
                                                                    </h4>
                                                                </div>
                                                                <div className={"sh-full-width-list"}>
                                                                    <i className={"ellipsis vertical blue icon"}></i>
                                                                    <h4 className={"content ui header"}>
                                                                        Click <span className={'hide-on-mobile'}>'Start Segmentation'</span><span className={'hide-on-tablet hide-on-computer'}>'Segment'</span> after selecting the file
                                                                    </h4>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={"sixteen wide mobile sixteen wide tablet eight wide computer column no-margin no-padding"}>
                                                    <div className={"container-fluid responsive-padding"}>
                                                        <Dropzone 
                                                            onDrop={this.onChangeFile.bind(this)}
                                                            onDragOver={() => this.setState({isDragHover: true})}
                                                            onDragLeave={() => this.setState({isDragHover: false})}
                                                        >
                                                            {({ getRootProps, getInputProps }) => (
                                                                <div {...getRootProps({
                                                                    className: `large shbg-blue-pallet ${this.state.isDragHover ? 'hundred' : 'fifty'} cursor_pointer content-block vertical-align-middle`,
                                                                    style: { border: 'dashed 1px #9cbfd8', padding: '1em' }
                                                                })}>
                                                                    <div className={"inner-content position-center text-align-center"}>
                                                                        <Image centered src='https://static.cctech.co.in/prod/images/common/icons/cloud-upload-icons-dark-grey-cctech.svg' size='small' style={{ width: '50px', paddingBottom: '1rem' }} />
                                                                        <h3 className={'ui header no-margin font-weight-bold'}>
                                                                            Select file
                                                                        </h3>
                                                                        <h4 className={'ui header text grey no-margin'}>
                                                                            <span className={'text blue font-weight-bold'}>drop</span> your file here or<br />click to <span className={'text blue font-weight-bold'}>browse</span> and select your file
                                                                        </h4>
                                                                        <input {...getInputProps()} accept=".stl" />
                                                                        {/* <input hidden id="upload" type="file" onChange={this.onChangeFile.bind(this)} accept=".stl" /> */}
                                                                        <h4 className={'ui header text grey'}>
                                                                            Selected file : {this.state.content}
                                                                        </h4>
                                                                        <Input fluid placeholder='Project name' id="filename" type="text" onClick={(e) => {e.preventDefault(); e.stopPropagation();}}
                                                                            onChange={this.onChangeFileName.bind(this)} value={this.state.filename} disabled={this.state.isButtonDisabled}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </Dropzone>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={"shbg-grey-pallet hundred ui segment no-border"}>
                                            <div className={'ui grid'}>
                                                <div className={"five wide mobile eight wide tablet eight wide computer column no-margin no-padding"}>
                                                    <div className={"container-fluid responsive-padding"}>
                                                        <div className={"content-block vertical-align-middle"}>
                                                            <div className={"inner-content position-left text-align-left"}>
                                                                <Route render={({ history }) => (
                                                                    <Button className={'ui red basic button'}
                                                                        onClick={() => {
                                                                            history.push('/')
                                                                        }}> Close
                                                                    </Button>
                                                                )} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={"eleven wide mobile eight wide tablet eight wide computer column no-margin no-padding"}>
                                                    <div className={"container-fluid responsive-padding"}>
                                                        <div className={"content-block vertical-align-middle"}>
                                                            <div className={"inner-content position-right text-align-right"}>
                                                                <Route render={({ history }) => (
                                                                    <Button className={'left-align-text ui right labeled icon primary large button'}
                                                                        onClick={() => {
                                                                            // this.props.handleSegmentation(this.state.file, history)
                                                                            this.createProject(history)
                                                                        }}
                                                                        disabled={this.state.isButtonDisabled} >
                                                                        <i className="right chevron icon"></i><span className={'hide-on-mobile'}>Start Segmentation</span><span className={'hide-on-tablet hide-on-computer'}>Segment</span>
                                                                    </Button>
                                                                )} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className={"inner-content position-center text-align-center"}>
                                    <div className={'container-limit max-width-700'}>
                                        <div className={'ui hidden divider'}></div>
                                        <h5 className={'ui header text grey'}>
                                            The machine learning algorithm may take some time to do the number-crunching and prepare results. So sit back and relax while we make your model feature reach.
                                        </h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ app }) => ({
    app,
});

export default connect(mapStateToProps)(UploadSTL);